var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { Footnote } from '@telus-uds/components-web';
import styled from 'styled-components';
import LegalContext from '../store/legal-context';
var LegalSup = function (_a) {
    var node = _a.node, addComma = _a.addComma, fontSize = _a.fontSize;
    var _b = useContext(LegalContext), addToLegalList = _b.addToLegalList, legalList = _b.legalList, handleLegalLinkClick = _b.handleLegalLinkClick;
    useEffect(function () {
        addToLegalList(node.data.target.id, node.data.target.sys.id, node.data.target.description);
    }, [node]);
    var legalIndex = legalList.findIndex(function (legal) { return legal.id === node.data.target.id; });
    var footnoteIndex = legalIndex > -1 ? legalIndex + 1 : null;
    return (legalList.length > 0 &&
        footnoteIndex && (_jsx(StyledLegalSup, { children: _jsx(Footnote.Link, { number: "".concat(footnoteIndex).concat(addComma ? ',' : ''), onClick: handleLegalLinkClick(footnoteIndex), variant: { size: fontSize } }) })));
};
LegalSup.displayName = 'LegalSup';
export default LegalSup;
var StyledLegalSup = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  sup {\n    line-height: 0; // UDS sets line-height to NANpx which causes a gap in the text\n    vertical-align: super; // overrides vertical-align: baseline set in KDS\n  }\n"], ["\n  sup {\n    line-height: 0; // UDS sets line-height to NANpx which causes a gap in the text\n    vertical-align: super; // overrides vertical-align: baseline set in KDS\n  }\n"])));
var templateObject_1;
